<template>
  <v-row class="align-center d-flex pa-md-3" no-gutters>
    <v-col cols="4">
      <span class="text-no-wrap pl-2 pr-2">Sorted by</span>
    </v-col>
    <v-col cols="8">
      <v-select
        @change="changeSortOrder"
        :value="order.value"
        :items="options"
        background-color="primary"
        class="pr-2"
        dark
        dense
        hide-details
        item-text="display"
        item-value="value"
        return-object
        rounded
        solo
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Sort",
  computed: {
    ...mapState({
      order: state => state.category.order
    })
  },
  data() {
    return {
      options: [
        { display: "Alphabetical", value: "alphabetical" },
        { display: "Popularity", value: "popularity" }
      ]
    };
  },
  methods: {
    changeSortOrder() {
      const order =
        this.order.value === "alphabetical" ? this.options[1] : this.options[0];
      this.$store.commit("category/CHANGE_SORT_ORDER", order);
      this.$store.dispatch(
        "category/restartFetch",
        this.$route.params.categoryId
      );
    }
  }
};
</script>
